import { BaseModel } from '../base.model';

export class EmailQueueDto extends BaseModel {
  public QueueName: string;
  public Subject: string;
  public Body: string;
  public EmailsTo: string;

  constructor(o: any = null) {
    super(o);
  }
}
